import SnackbarResponse from './SnackbarResponse';
export default SnackbarResponse;